import { render, staticRenderFns } from "./ModalDisplay.vue?vue&type=template&id=45e08671&scoped=true"
import script from "./ModalDisplay.vue?vue&type=script&lang=ts"
export * from "./ModalDisplay.vue?vue&type=script&lang=ts"
import style0 from "./ModalDisplay.vue?vue&type=style&index=0&id=45e08671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e08671",
  null
  
)

export default component.exports